import Vue from "vue";

import "normalize.css/normalize.css"; // A modern alternative to CSS resets

import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
// import locale from 'element-ui/lib/locale/lang/en' // lang i18n

import "@/styles/index.scss"; // global css

import App from "./App";
import store from "./store";
import router from "./router";

import i18n from "./locales"; // internationalization
import "@/icons"; // icon
import "@/permission"; // permission control

import api from "@/api/api.js";
import moment from "moment";

import { simpleFixed } from "@/utils";
Vue.prototype.simpleFixed = simpleFixed;

// 固定数据
import virtualData from "@/utils/data";
Vue.prototype.virtualData = virtualData;

// 工具类
import tools from "@/utils/tools";
Vue.prototype.$tools = tools;

// 全局过滤器
import filters from "./filters";
Object.keys(filters).forEach((key) => {
    Vue.filter(key, filters[key]);
});

// 全局挂载方法
Vue.prototype.$api = api;
Vue.prototype.moment = moment;

// 分页组件
import Pagination from "@/components/Pagination";
Vue.component("Pagination", Pagination);

// set ElementUI lang to EN
Vue.use(ElementUI, { i18n: (key, value) => i18n.t(key, value) });
// 如果想要中文版 element-ui，按如下方式声明
// Vue.use(ElementUI)

import { touristMixin } from '@/utils/mixin';
Vue.mixin(touristMixin)

Vue.config.productionTip = false;

new Vue({
    el: "#app",
    router,
    store,
    i18n,
    render: (h) => h(App),
});
